import AComponent from './A.svelte';
export * from './A.types.js';
const A = AComponent;
export { A };
import AsideComponent from './Aside.svelte';
export * from './Aside.types.js';
const Aside = AsideComponent;
export { Aside };
import ButtonComponent from './Button.svelte';
export * from './Button.types.js';
const Button = ButtonComponent;
export { Button };
import DivComponent from './Div.svelte';
export * from './Div.types.js';
const Div = DivComponent;
export { Div };
import EmComponent from './Em.svelte';
export * from './Em.types.js';
const Em = EmComponent;
export { Em };
import FooterComponent from './Footer.svelte';
export * from './Footer.types.js';
const Footer = FooterComponent;
export { Footer };
import H1Component from './H1.svelte';
export * from './H1.types.js';
const H1 = H1Component;
export { H1 };
import H2Component from './H2.svelte';
export * from './H2.types.js';
const H2 = H2Component;
export { H2 };
import H3Component from './H3.svelte';
export * from './H3.types.js';
const H3 = H3Component;
export { H3 };
import H4Component from './H4.svelte';
export * from './H4.types.js';
const H4 = H4Component;
export { H4 };
import H5Component from './H5.svelte';
export * from './H5.types.js';
const H5 = H5Component;
export { H5 };
import H6Component from './H6.svelte';
export * from './H6.types.js';
const H6 = H6Component;
export { H6 };
import HeaderComponent from './Header.svelte';
export * from './Header.types.js';
const Header = HeaderComponent;
export { Header };
import HrComponent from './Hr.svelte';
export * from './Hr.types.js';
const Hr = HrComponent;
export { Hr };
import IComponent from './I.svelte';
export * from './I.types.js';
const I = IComponent;
export { I };
import ImgComponent from './Img.svelte';
export * from './Img.types.js';
const Img = ImgComponent;
export { Img };
import LabelComponent from './Label.svelte';
export * from './Label.types.js';
const Label = LabelComponent;
export { Label };
import LiComponent from './Li.svelte';
export * from './Li.types.js';
const Li = LiComponent;
export { Li };
import MainComponent from './Main.svelte';
export * from './Main.types.js';
const Main = MainComponent;
export { Main };
import NavComponent from './Nav.svelte';
export * from './Nav.types.js';
const Nav = NavComponent;
export { Nav };
import PComponent from './P.svelte';
export * from './P.types.js';
const P = PComponent;
export { P };
import SectionComponent from './Section.svelte';
export * from './Section.types.js';
const Section = SectionComponent;
export { Section };
import SpanComponent from './Span.svelte';
export * from './Span.types.js';
const Span = SpanComponent;
export { Span };
import StrongComponent from './Strong.svelte';
export * from './Strong.types.js';
const Strong = StrongComponent;
export { Strong };
import SvgComponent from './Svg.svelte';
export * from './Svg.types.js';
const Svg = SvgComponent;
export { Svg };
import UlComponent from './Ul.svelte';
export * from './Ul.types.js';
const Ul = UlComponent;
export { Ul };
//# sourceMappingURL=index.js.map